import { apply, composeMatrices, matrices } from './matrices';
import type { CoordinateTransformContext } from './types';

// ============================================================================
// Coordinate transformation API
// Provides transform functions for each coordinate space transition
// More can be added when needed
// ============================================================================

export const coordinates = {
  point: {
    // Content → Canvas → Viewport
    contentToViewport: (ctx: CoordinateTransformContext) =>
      apply.point(
        composeMatrices(
          matrices.content.toCanvas(ctx.contentPadding, ctx.canvasTransform),
          matrices.canvas.toViewport(ctx.canvasTransform)
        )
      ),

    // Viewport → Canvas → Content
    viewportToContent: (ctx: CoordinateTransformContext) =>
      apply.point(
        composeMatrices(
          matrices.viewport.toCanvas(ctx.canvasTransform),
          matrices.canvas.toContent(ctx.contentPadding, ctx.canvasTransform)
        )
      ),

    // Screen → Viewport
    screenToViewport: (ctx: CoordinateTransformContext) =>
      apply.point(matrices.screen.toViewport(ctx.viewportRect)),

    // Screen → Viewport → Canvas → Content
    screenToContent: (ctx: CoordinateTransformContext) =>
      apply.point(
        composeMatrices(
          matrices.screen.toViewport(ctx.viewportRect),
          matrices.viewport.toCanvas(ctx.canvasTransform),
          matrices.canvas.toContent(ctx.contentPadding, ctx.canvasTransform)
        )
      ),
  },

  scalar: {
    // Content → Canvas → Viewport
    contentToViewport: (ctx: CoordinateTransformContext) =>
      apply.scalar(
        composeMatrices(
          matrices.content.toCanvas(ctx.contentPadding, ctx.canvasTransform),
          matrices.canvas.toViewport(ctx.canvasTransform)
        )
      ),

    // Viewport → Canvas → Content
    viewportToContent: (ctx: CoordinateTransformContext) =>
      apply.scalar(
        composeMatrices(
          matrices.viewport.toCanvas(ctx.canvasTransform),
          matrices.canvas.toContent(ctx.contentPadding, ctx.canvasTransform)
        )
      ),
  },

  rect: {
    // Content → Canvas → Viewport
    contentToViewport: (ctx: CoordinateTransformContext) =>
      apply.rect(
        composeMatrices(
          matrices.content.toCanvas(ctx.contentPadding, ctx.canvasTransform),
          matrices.canvas.toViewport(ctx.canvasTransform)
        )
      ),

    // Viewport → Canvas → Content
    viewportToContent: (ctx: CoordinateTransformContext) =>
      apply.rect(
        composeMatrices(
          matrices.viewport.toCanvas(ctx.canvasTransform),
          matrices.canvas.toContent(ctx.contentPadding, ctx.canvasTransform)
        )
      ),

    // Screen → Viewport → Canvas → Content
    screenToContent: (ctx: CoordinateTransformContext) =>
      apply.rect(
        composeMatrices(
          matrices.screen.toViewport(ctx.viewportRect),
          matrices.viewport.toCanvas(ctx.canvasTransform),
          matrices.canvas.toContent(ctx.contentPadding, ctx.canvasTransform)
        )
      ),
  },
};
